<template>
  <div class="relative inline-block">
    <!-- Dropdown Button -->
    <button
      @click="toggleDropdown"
      class="btn btn-primary flex items-center gap-1"
      type="button"
    >
      + New
      <svg
        class="w-4 h-4 transition-transform duration-200"
        :class="{ 'rotate-180': isOpen }"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <!-- Dropdown Menu -->
    <div
      v-if="isOpen"
      class="absolute left-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-50 min-w-48"
      @click.stop
    >
      <div class="py-1">
        <button
          v-for="item in items"
          :key="item.value"
          @click="selectItem(item.value)"
          class="w-full text-left px-4 py-2 text-sm hover:bg-gray-100 hover:text-gray-900 transition-colors duration-150"
        >
          {{ item.label }}
        </button>
      </div>
    </div>

    <!-- Backdrop to close dropdown when clicking outside -->
    <div
      v-if="isOpen"
      @click="closeDropdown"
      class="fixed inset-0 z-40"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'NewItemDropdown',
  props: {
    items: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      isOpen: false
    }
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen
    },
    closeDropdown() {
      this.isOpen = false
    },
    selectItem(value) {
      this.$emit('item-selected', value)
      this.closeDropdown()
    }
  },
  mounted() {
    // Close dropdown when pressing Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.closeDropdown()
      }
    })
  }
}
</script>

<style scoped>
.rotate-180 {
  transform: rotate(180deg);
}
</style>
